import {createSelector} from '@ngrx/store';


import {AppState} from '../../../reducers/index';
import * as fromSampleFormReducer from './sample-form.reducer';

export const currentState = (state: AppState) => (state[fromSampleFormReducer.sampleFormsFeatureKey]);

export const selectAllSampleForm = createSelector(currentState, fromSampleFormReducer.selectAll);

export const selectTotalSampleForm = createSelector(currentState, fromSampleFormReducer.selectTotal);

export const selectModifiedSampleForms = createSelector(selectAllSampleForm, (serviceForms) => {
  return serviceForms.map((serviceForm) => {
    return {
      ...serviceForm
    };
  });
});

export const selectModifiedSampleFormByUid= (uniqueId) => createSelector(selectAllSampleForm, (sampleForms) =>
sampleForms.find((sampleForm) => sampleForm.formUniqueId === uniqueId));
